/**
 * Copyright (c) 2017-present, Epicurean.
 *
 * This exports constants related to organization setting keys.
 * @format
 */

// Keeps column configuration of deal table
export const DEAL_TABLE_COLUMNS = 'deal_table_columns';

// will indicate whether signals is enabled for the organization
export const IS_SIGNALS_ENABLED = 'is_signals_enabled';

// will hold the value of the organization's email sync method
export const EMAIL_SYNC_METHOD = 'email_sync_method';

// will hold the value of the organization's email sync method
export const FORWARDING_EMAIL_ADDRESS = 'forwarding_email_address';

// is portfolio module enabled?
export const IS_PORTFOLIO_ENABLED = 'is_portfolio_enabled';

// is fund management enabled?
export const IS_FUND_MANAGEMENT_ENABLED = 'is_fund_management_enabled';

export const IS_FUND_LP_RELATIONSHIP_MANAGEMENT_ENABLED =
  'is_fund_lp_relationship_management_enabled';

// IS special-case mis report generation functionality enabled?
export const IS_20210710_MIS_REPORT_ENABLED = 'is_20210710_mis_report_enabled';

// is whatsapp feature enabled?
export const IS_WHATSAPP_ENABLED = 'is_whatsapp_enabled';

// is analytics v2 enabled?
export const IS_ANALYTICS_V2_ENABLED = 'is_analytics_v2_beta_enabled';

//cubejs_schema_version
export const CUBEJS_SCHEMA_VERSION = 'cubejs_schema_version';
// is sign offs feature enabled?
export const IS_SIGN_OFFS_ENABLED = 'is_sign_offs_enabled';

// is portfolio analytics enabled?
export const IS_PORTFOLIO_ANALYTICS_ENABLED = 'is_portfolio_analytics_enabled';

// is derived sheets enabled?
export const IS_DERIVED_SHEET_ENABLED = 'is_derived_sheet_enabled';

//Is custom field data for individual deal enabled?
export const IS_CUSTOM_FIELD_DATA_FOR_INDIVIDUAL_DEAL_ENABLED =
  'is_displaying_custom_fields_for_individual_deal_enabled';

// Is this organization allowed to disable password based login to its members?
export const IS_DISABLE_PASSWORD_FEATURE_ENABLED =
  'is_disable_password_feature_enabled';

// Is password based login disabled?
export const IS_PASSWORD_LOGIN_DISABLED = 'is_password_login_disabled';

// Is feature portfolio Intelligence Enabled?
export const IS_PORTFOLIO_INTELLIGENCE_ENABLED =
  'is_portfolio_intelligence_enabled';

//Is the pdf mis import feature enabled
export const IS_PDF_MIS_IMPORT_ENABLED = 'is_pdf_mis_import_enabled';

// Is feature contact Book Enabled?
export const IS_CONTACT_BOOK_ENABLED = 'is_contact_book_enabled';

// is fund of funds enabled?
export const IS_FUND_OF_FUNDS_ENABLED = 'is_fund_of_funds_enabled';

// is family office enabled?
export const IS_FAMILY_OFFICE_ENABLED = 'is_family_office_enabled';
// Is feature Email Search Enabled?
export const IS_EMAIL_SEARCH_ENABLED = 'is_email_search_enabled';

// Is feature Pitch Deck Parser Enabled?
export const IS_PITCH_DECK_PARSER_ENABLED = 'is_pitch_deck_parser_enabled';

// Is feature LP Dashboard Enabled?
export const IS_LP_DASHBOARD_ENABLED = 'is_lp_dashboard_enabled';

//Team members quota
export const TEAM_MEMBERS_QUOTA = 'team_members_quota';
// Is feature Fund transactions Enabled?
export const IS_FUND_TRANSACTIONS_ENABLED = 'is_fund_transactions_enabled';

//Is ageing report enabled?
export const IS_AGEING_REPORT_ENABLED = 'is_ageing_report_enabled';
// Is data export enabled for portfolio
export const IS_DATA_EXPORT_ENABLED = 'is_data_export_enabled';

// Is blurring unassigned deal for pipeline members enabled?
export const IS_BLUR_UNASSIGNED_DEALS_FOR_PIPELINE_MEMBERS_ENABLED =
  'is_blur_unassigned_deals_for_pipeline_members_enabled';

export const IS_CONSOLIDATED_PORTFOLIO_REPORTING_ENABLED =
  'is_consolidated_portfolio_reporting_enabled';
// Is pitch submissions enabled?
export const IS_PITCH_SUBMISSIONS_ENABLED = 'is_pitch_submissions_enabled';
// Will indicate whether serial number settings enabled or not

export const IS_SERIAL_NUMBER_FOR_TABLES_ENABLED =
  'is_serial_number_for_tables_enabled';

export const IS_MAKER_CHECKER_ENABLED = 'is_maker_checker_enabled';
//Will indicate if recurring remindes should be enabled or not
export const IS_RECURRING_REMINDERS_ENABLED = 'is_recurring_reminders_enabled';

//Is reminders dashboard enabled for this org
export const IS_REMINDERS_DASHBOARD_ENABLED = 'is_reminders_dashboard_enabled';
export const IS_SHARE_DEALS_WITH_TEMPLATES_ENABLED =
  'is_share_deals_with_templates_enabled';

// Is aggregate rows enabled for this org
export const IS_AGGREGATE_ROW_ENABLED = 'is_aggregate_row_enabled';
// Is task management enabled for this org
export const IS_TASK_MANAGEMENT_ENABLED = 'is_task_management_enabled';
export const IS_CONTACT_LISTS_ENABLED = 'is_contact_lists_enabled';

// The feature flag for the Formula Builder in Dealflow,
// which allows the creation of custom formula fields based on existing custom fields.
export const IS_FORMULA_BUILDER_FOR_DEALFLOW_ENABLED =
  'is_formula_builder_for_dealflow_enabled';
